export default __webpack_public_path__ + "static/avatar-5e6bf9a3f05776fe9564e28cca8d0857.jpg";